import React, { useState, useEffect, useMemo, useCallback } from "react"; 
import Sidebar from "../../Component/Sidebar/Sidebar";
import Transaction from "../../Component/TransactionTable/Transactiontable";
import Header from "../../Component/Header/Header";
import "./transactionpage.css";

function TransactionPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // ===== ADD: deteksi mobile/tablet
  const getIsMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1024px)").matches;

  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1024px)");
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    // di mobile sidebar tertutup default; di desktop terbuka
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  // ===== ADD: kelola kelas DOM
  const applyDomClasses = useCallback(
    (open) => {
      const body = document.body;
      const sidebarEl = document.querySelector(".transaction-page .sidebar");
      const overlayEl = document.querySelector(".transaction-page .sidebar-overlay");
      if (isMobile) {
        if (open) {
          sidebarEl?.classList.add("is-mobile-open");
          overlayEl?.classList.add("is-visible");
          body.classList.add("lock-scroll");
        } else {
          sidebarEl?.classList.remove("is-mobile-open");
          overlayEl?.classList.remove("is-visible");
          body.classList.remove("lock-scroll");
        }
      } else {
        sidebarEl?.classList.remove("is-mobile-open");
        overlayEl?.classList.remove("is-visible");
        body.classList.remove("lock-scroll");
      }
    },
    [isMobile]
  );

  useEffect(() => {
    applyDomClasses(isSidebarOpen);
  }, [isSidebarOpen, applyDomClasses]);

  const toggleSidebar = () => setIsSidebarOpen((v) => !v);
  const handleOverlayClick = () => setIsSidebarOpen(false);

  // ===== ADD: kelas main-content menyesuaikan
  const mainContentClass = useMemo(() => {
    if (isMobile) return "main-content sidebar-closed";
    return `main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`;
  }, [isMobile, isSidebarOpen]);

  return (
    <div className="transaction-page">
      <Sidebar isOpen={isSidebarOpen} />

      {/* ADD: overlay */}
      <div className="sidebar-overlay" onClick={handleOverlayClick} aria-hidden={!isSidebarOpen} />

      <div className={mainContentClass}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="transaction-content">
          <Transaction />
        </div>
        <footer className="transaction-footer">
          <p>@copyright 2025 - LacaKas</p>
        </footer>
      </div>
    </div>
  );
}

export default TransactionPage;